import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { Collapse, Icon } from '@material-ui/core';
import FilterSettingModal from '../FilterSettingModal';
import Button from '../../atoms/Button';
import Drawer from '../../atoms/Drawer';
import IconButton from '../../atoms/IconButton';
import Form from '../../molecules/Form';
import Checkbox from '../../atoms/Checkbox';
import {
  formatDate,
  DATE_YYYYMMDD,
  getInquiryToday,
  formatDateNull,
  getFindIndex,
  getSpecifiedCondition,
  SESSION_STORAGE_NEGOTATION_KEYS,
  setStorageValueByKey,
  DEFAULT_PAGE_VIEW,
  SALE_MANCD_NAME_KEY,
  getCompanyCfcDisplayName,
  KEPT_SEARCH_CONDITION_NAMES,
  FILTER_SECTIONS_KEY,
  FREEWORD_SEARCH_MAPPING,
} from '../../../Common';
import { AppState } from '../../../redux/modules/store';
import {
  fetchCustomFilter,
  updateCategory,
  updateCurrentFilter,
  updateRefresh,
  updateSearchCondition,
} from '../../../redux/operations/FilterSettingDrawer';
import { filterConditionState, filterKeyState, initialCurrentFilterState } from '../../../redux/reducers/CurrentFilterReducer';
import {
  initialState as initialSearchConditionState,
  SearchConditionState,
  SearchConditionItem,
} from '../../../redux/reducers/SearchConditionReducer';
import { StoreAndAgencyInfo, StoreSelectorState } from '../../../redux/reducers/StoreSelectorReducer';
import ActDatepicker from '../../organisms/ActDatepicker';
import StoreSelectModal from '../StoreSelectModal';
import { Badge } from '../../atoms/Badge';
import { actions } from '../../../redux/modules/Actions';
import Select from '../../atoms/Select';
import { masterDetailApiGetAllPcmCode } from '../../..//external/MasterDetailApi';
import { PcmCodeInfo } from '../../../external/MasterDetailApi';
import { UserState } from '../../../redux/reducers/UserReducer';
import { SearchCategoryState, initialState as initialStateSearchCategory } from '../../../redux/reducers/SearchCategoryReducer';
import { getAgencyStoreShortName, getConditionTitle, getItemNames, getSearchConditionNoEmpty } from './function';
import { StoreInfo } from '../../../external/StoresApi';
import { GASpotEventState } from '../NegotiationCountList';
import ButtonGroup from '../../atoms/ButtonGroup';

interface FilterSettingDrawerProps {
  isOpen: boolean;
  gaSpotEvent?: {
    [key: string]: {
      [key: string]: GASpotEventState;
    };
  };
  onClose: () => void;
  search: (
    loginUser: UserState,
    storeSelector: StoreSelectorState,
    filterConditions: SearchConditionState,
    isPagingInitialized: boolean,
    dropDownSelect?: string,
  ) => void;
  setSearchBranchCount?: (val: number) => void;
  setCurrentPage?: (val: number) => void;
  setPaging?: (val: object) => void;
  setApiUpdateIndex?: (val: number) => void;
  isSearchImprovement?: boolean;
  postCd?: string;
  storeFilterNode?: React.ReactNode;
  isMailAddressSelect?: boolean;
  isCalledByCustomerList?: boolean;
  disableAutoSearchByStoreSelector?: boolean;
}

interface FilterOption {
  key: string;
  title: string;
  selected: boolean;
}

interface Duration {
  category: string;
  value: (string | null)[];
}

const DURATION = {
  FROM: 0,
  TO: 1,
};

const initialDurationState = { category: '', value: ['', ''] };

export const CHECKBOX_LIST_LABEL = {
  NEGOTIATION: {
    CLOSING_SALE_MANCD: '自分が登録した商談のみ',
    MAIN_CLOSING_SALE_MANCD: '自分が担当している商談のみ',
  },
  MAIL: {
    CLOSING_SALE_MANCD: '自分が登録した商談を含むお客さま',
    MAIN_CLOSING_SALE_MANCD: '自分が担当している商談を含むお客さま',
  },
};

export const DESCRIPTION_FREEWORD_FIELD = {
  CREW: 'お客さま番号、お客さま氏名、フリガナ、商談メモなど',
  OTHER: 'お客さま番号、担当者名またはクルーコード、臨時コード、見積書番号',
};

interface FreewordConditionNameType {
  conditionName: string;
  label: string;
  dataTestId: string;
}

const SORT_FIELDS = ['kanaName', 'longName', 'shortName', 'companyCfc'] as const;

const FilterSettingDrawer: React.FC<FilterSettingDrawerProps> = ({
  isOpen,
  gaSpotEvent,
  onClose,
  search,
  postCd,
  storeFilterNode,
  isMailAddressSelect,
  setSearchBranchCount,
  setCurrentPage,
  isSearchImprovement,
  setPaging,
  setApiUpdateIndex,
  children,
  isCalledByCustomerList,
  disableAutoSearchByStoreSelector,
}) => {
  const isCrewModule = process.env.REACT_APP_MODULE === 'crew';
  const isEmployeeModule = process.env.REACT_APP_MODULE === 'employee';
  const dispatch = useDispatch();
  const loginUser = useSelector((state: AppState) => state.loginUser);
  const storeSelector = useSelector((state: AppState) => state.storeSelector);
  const filterStore = useSelector((state: AppState) => state.filterStore);
  const globalCurrentFilter = useSelector((state: AppState) => state.currentFilterCondition);
  const globalSearchCondition = useSelector((state: AppState) =>
    isCalledByCustomerList ? state.searchCustomerListCondition.filterState : state.SearchCondition,
  );
  const filterList = useSelector((state: AppState) => state.filterList);
  const freewordRef = useRef<HTMLInputElement>(null);
  const [currentFilter, setCurrentFilter] = useState<filterKeyState>(initialCurrentFilterState);
  const [searchCondition, setSearchCondition] = useState<SearchConditionState>(initialSearchConditionState);
  const [duration, setDuration] = useState<Duration>(initialDurationState);
  const [durationValueFrom, setDurationValueFrom] = useState<string | null>('');
  const [durationValueTo, setDurationValueTo] = useState<string | null>('');
  const [showAllConditionDisplayValue, setShowAllConditionDisplayValue] = useState<string>('');
  const [isCollapsedOther, setIsCollapsedOther] = useState<boolean>(false);
  const [isCollapsedStore, setIsCollapsedStore] = useState<boolean>(false);
  const [isDispStore, setIsDispStore] = useState<boolean>(false);
  const [isOpenFilterSettingModal, setIsOpenFilterSettingModal] = useState<boolean>(false);
  const [isOpenStoreSelectModal, setIsOpenStoreSelectModal] = useState<boolean>(false);
  const fetchLoadingStatus = useSelector((state: AppState) => state.loadingStatus.summary);
  const inquiryToday = getInquiryToday(fetchLoadingStatus.result?.jobDateTime);
  const [pcmCodeInfoList, setPcmCodeInfoList] = useState([] as Array<PcmCodeInfo>);
  const [selectCodeInfo, setSelectCodeInfo] = useState('');
  const [searchCategory, setSearchCategory] = useState<SearchCategoryState>(initialStateSearchCategory);
  const [freewordConditionName, setFreewordConditionName] = useState<string>('');

  const [isCheckedMyCustomer, setIsCheckedMyCustomer] = useState<boolean>(false);
  const [isCheckedMyNegotiation, setIsCheckedMyNegotiation] = useState<boolean>(false);

  const hasCrewNameOnSearchCategories: boolean = useMemo(() => {
    // if (!searchCategory) return false;
    const avarableCrewNameList =
      searchCategory.categories
        .find((v) => v.largeCategoryCd === '02')
        ?.middleCategory.find((v) => v.middleCategoryCd === '03')
        ?.smallCategory?.map((v) => v.smallCategoryCdName) || [];
    return avarableCrewNameList.includes(loginUser.crewName);
  }, [searchCategory, loginUser.crewName]);

  const DURATION_DISPLAY_OPTIONS = [
    ['', ''],
    ['createDate', '初回登録日'],
    ['latestUpdateDate', '最終更新日'],
    ['actionDate', 'アクション予定日'],
    // ['callDate', '架電予定日'],
    // ['comeDate', '来店予定日'],
  ];

  // get the value of small category name according to crew code
  const getSmallCategoryCdName = (key: string) => {
    return (
      searchCategory?.categories[1]?.middleCategory
        .find((item) => item.middleCategoryCdMapping === key)
        ?.smallCategory?.find((item) => item.smallCategoryCd === loginUser.crewCd)?.smallCategoryCdName || ''
    );
  };

  // init list checkbox sales man cd name
  const listCheckboxSalesManCdName = useMemo(() => {
    if (!isSearchImprovement) return [];
    return [
      {
        key: SALE_MANCD_NAME_KEY.CLOSING_SALE_MANCD,
        value: getSmallCategoryCdName(SALE_MANCD_NAME_KEY.CLOSING_SALE_MANCD),
        label: isMailAddressSelect ? CHECKBOX_LIST_LABEL.MAIL.CLOSING_SALE_MANCD : CHECKBOX_LIST_LABEL.NEGOTIATION.CLOSING_SALE_MANCD,
        dataTestId: 'filterSettingDrawer-checkbox-closingSaleManName',
      },
      {
        key: SALE_MANCD_NAME_KEY.MAIN_CLOSING_SALE_MANCD,
        value: getSmallCategoryCdName(SALE_MANCD_NAME_KEY.MAIN_CLOSING_SALE_MANCD),
        label: isMailAddressSelect
          ? CHECKBOX_LIST_LABEL.MAIL.MAIN_CLOSING_SALE_MANCD
          : CHECKBOX_LIST_LABEL.NEGOTIATION.MAIN_CLOSING_SALE_MANCD,
        dataTestId: 'filterSettingDrawer-checkbox-mainClosingSaleManName',
      },
    ];
  }, [isMailAddressSelect, isCalledByCustomerList, isSearchImprovement, searchCategory]);

  const drawerSpotEvent = gaSpotEvent ? gaSpotEvent[FILTER_SECTIONS_KEY.DRAWER] : undefined;
  const closeSpotEvent = drawerSpotEvent?.close;
  const clearSpotEvent = drawerSpotEvent?.clear;
  const executeSpotEvent = drawerSpotEvent?.execute;
  const addConditionSpotEvent = drawerSpotEvent?.addCondition;

  const currentFreewordMapping: FreewordConditionNameType[] = useMemo(() => {
    const searchConditionMapping: { [key: string]: string } = FREEWORD_SEARCH_MAPPING[isMailAddressSelect ? 'MAIL' : 'NEGOTIATION'];
    const freewordGroupButtons: FreewordConditionNameType[] = [
      {
        conditionName: searchConditionMapping.FULL,
        label: '全体検索',
        dataTestId: 'freeword-full',
      },
      {
        conditionName: searchConditionMapping.CUSTOMER_NUMBER_ONLY,
        label: 'お客さま番号のみ',
        dataTestId: 'freeword-customer-number-only',
      },
    ];
    if (isSearchImprovement) {
      freewordGroupButtons.push({
        conditionName: searchConditionMapping.CUSTOMER_NAME_ONLY,
        label: 'お客さま氏名のみ',
        dataTestId: 'freeword-customer-name-only',
      });
    }
    return freewordGroupButtons;
  }, [isSearchImprovement, isMailAddressSelect]);

  const defaultFreewordConditionName: string = FREEWORD_SEARCH_MAPPING[isMailAddressSelect ? 'MAIL' : 'NEGOTIATION'].FULL;

  // change search condition when have action with checkbox
  const changeSeachCondition = (key: string, value: string, checked: boolean) => {
    let searchDataTemp = [...searchCondition];
    let hasKey = false;
    const initCheckBoxValue: any = {
      searchConditionName: key,
      checked: true,
      specifiedCondition: value ? [value] : [],
    };

    if (!searchDataTemp.length) {
      searchDataTemp.push(initCheckBoxValue);
      return searchDataTemp;
    }

    searchDataTemp = searchDataTemp.map((item) => {
      if (item.searchConditionName === key) {
        hasKey = true;
        if (checked) {
          item = { ...initCheckBoxValue };
        } else {
          item.specifiedCondition = item.specifiedCondition?.filter((nameCd) => nameCd !== value);
          item.checked = false;
        }
      }
      return item;
    });

    if (!hasKey) {
      searchDataTemp.push(initCheckBoxValue);
    }

    return searchDataTemp;
  };

  //function check checked checkbox
  const isChecked = (key: string) => {
    const hasSmallCategoryCdName = searchCondition.find((item) => item.checked)?.specifiedCondition?.includes(getSmallCategoryCdName(key));
    const objTempOfKey = searchCondition.find((item) => item.searchConditionName === key);

    return (
      (hasSmallCategoryCdName && objTempOfKey?.checked && objTempOfKey?.specifiedCondition.length === 1) ||
      (!hasSmallCategoryCdName && objTempOfKey?.checked && objTempOfKey?.specifiedCondition.length === 0)
    );
  };

  const onOpenDrawer = async () => {
    const searchCategoryFetch = await updateCategory(loginUser, storeSelector, dispatch);
    setSearchCategory(searchCategoryFetch);
    freewordRef.current?.focus();
    let duration: Duration = initialDurationState;

    DURATION_DISPLAY_OPTIONS.forEach((data) => {
      if (data[0] && getFindIndex(globalSearchCondition, data[0]) !== -1) {
        const durationSpecifiedCondition = getSpecifiedCondition(globalSearchCondition, data[0]);
        duration = { category: data[0], value: durationSpecifiedCondition };
        setDurationValueFrom(durationSpecifiedCondition[DURATION.FROM] ? durationSpecifiedCondition[DURATION.FROM] : '');
        setDurationValueTo(durationSpecifiedCondition[DURATION.TO] ? durationSpecifiedCondition[DURATION.TO] : '');
      }
    });
    const currentFreewordCondition = globalSearchCondition.find((itemStateGlobal) =>
      currentFreewordMapping.some((item) => itemStateGlobal.searchConditionName === item.conditionName),
    );
    setFreewordConditionName(currentFreewordCondition?.searchConditionName || defaultFreewordConditionName);
    setSearchCondition(globalSearchCondition);
    setCurrentFilter(globalCurrentFilter);
    setDuration(duration);
  };

  const onChangeFilter = (filterKey: string) => {
    const keptSearchConditionNames: { [key: string]: boolean } = { ...KEPT_SEARCH_CONDITION_NAMES, [freewordConditionName]: true };
    // filter to get search data of fields "期間", "フリーワード" and "追加条件" to keep search condition
    const keptSearchConditions = searchCondition?.filter((item) => !!keptSearchConditionNames[item.searchConditionName]) || [];
    if (!filterKey) {
      setCurrentFilter(initialCurrentFilterState);
      return;
    }
    const filterListCopy: filterConditionState[] = JSON.parse(JSON.stringify(filterList));
    const filterCondition = filterListCopy.find((filter) => filter.filterKey === filterKey);

    if (filterCondition) {
      // retain the search data of fields "期間", "フリーワード" and "追加条件" when making changes
      const finalSearchCondition = keptSearchConditions.concat(filterCondition.searchConditions);
      setSearchCondition(finalSearchCondition);
      setCurrentFilter({ filterKey: filterCondition.filterKey, filterTitle: filterCondition.filterTitle });
    }
  };

  const onChangeFreeword = (freeword: string) => {
    let freewordSearchCondition: SearchConditionState = [];
    freewordSearchCondition = [...searchCondition];

    // Step1. 文字列生成
    const valueArray: string[] = freeword.replace(/　/g, ' ').split(' ');
    // Step2. SearchCondition State上のkeyword存在確認
    const findIndex = getFindIndex(freewordSearchCondition, freewordConditionName);

    if (findIndex !== -1) {
      // ある場合、更新
      freewordSearchCondition[findIndex] = {
        ...freewordSearchCondition[findIndex],
        specifiedCondition: freeword ? valueArray : [],
      };
    } else {
      // ない場合、新規
      freewordSearchCondition.push({
        searchConditionName: freewordConditionName,
        specifiedCondition: valueArray,
      });
    }
    setSearchCondition(freewordSearchCondition);
  };

  const onChangeFreewordConditionName = (conditionName: string) => {
    let newSearchCondition: SearchConditionState = [];
    newSearchCondition = [...searchCondition].filter((item) => item.searchConditionName !== freewordConditionName);
    newSearchCondition.push({
      searchConditionName: conditionName,
      specifiedCondition: freewordRef.current?.value ? [freewordRef.current.value] : [],
    });
    setFreewordConditionName(conditionName);
    setSearchCondition(newSearchCondition);
  };

  const onChangeDuration = (durationCategory: string) => {
    const durationCopy = Object.assign({}, duration);

    let filteredSearchCondition: SearchConditionState = [...searchCondition];
    // Step1. 期間に該当する SearchConditionStateを削除
    DURATION_DISPLAY_OPTIONS.forEach((data) => {
      filteredSearchCondition = filteredSearchCondition.filter((key) => key.searchConditionName !== data[0]);
    });

    const durationSearchCondition: SearchConditionState = [...filteredSearchCondition];

    durationCopy.category = durationCategory;
    // 期間 FROM/TOが残っている場合、新しい期間指定条件追加
    if (durationCopy.category) {
      durationSearchCondition.push({
        searchConditionName: durationCopy.category,
        specifiedCondition: [durationCopy.value[DURATION.FROM] || DATE_YYYYMMDD.MIN, durationCopy.value[DURATION.TO] || DATE_YYYYMMDD.MAX],
      });
    }

    setSearchCondition(durationSearchCondition);
    setDuration(durationCopy);
  };

  const onChangeDurationValue = (num: number, date: string) => {
    const formattedDate = formatDate(date, 'YYYY-MM-DD', 'YYYYMMDD') || (num ? DATE_YYYYMMDD.MAX : DATE_YYYYMMDD.MIN);
    num === DURATION.FROM ? setDurationValueFrom(formattedDate) : setDurationValueTo(formattedDate);
    const durationCopy = Object.assign({}, duration);
    durationCopy.value[num] = formattedDate;
    if (num === DURATION.FROM) {
      // From入力onChangeの場合
      // Toを補填(空文字→99991231)する。
      const compensationDate = durationValueTo || DATE_YYYYMMDD.MAX;
      setDurationValueTo(compensationDate);
      durationCopy.value[DURATION.TO] = compensationDate;
    }
    if (num === DURATION.TO) {
      // To入力onChangeの場合
      // Fromを補填(空文字→19000101)する。
      const compensationDate = durationValueFrom || DATE_YYYYMMDD.MIN;
      setDurationValueFrom(compensationDate);
      durationCopy.value[DURATION.FROM] = durationValueFrom || DATE_YYYYMMDD.MIN;
    }

    const durationSearchCondition: SearchConditionState = [...searchCondition];
    if (durationCopy.value[DURATION.FROM] || durationCopy.value[DURATION.TO]) {
      const findIndex = getFindIndex(durationSearchCondition, durationCopy.category);
      if (findIndex !== -1) {
        durationSearchCondition[findIndex] = {
          ...durationSearchCondition[findIndex],
          specifiedCondition: durationCopy.value,
        };
      }
      setSearchCondition(durationSearchCondition);
    } else {
      const filteredDurationSearchCondition = durationSearchCondition.filter((key) => key.searchConditionName !== durationCopy.category);
      setSearchCondition(filteredDurationSearchCondition);
    }
    setDuration(durationCopy);
  };

  const onRemoveSearchConditionSingleValue = (property: string) => {
    const searchConditionCopy = searchCondition.filter((item) => item.searchConditionName !== property);

    setSearchCondition(searchConditionCopy);
    setCurrentFilter(initialCurrentFilterState);
    setDuration(getExistDurationInSearchConditionState(searchConditionCopy));
  };

  const onSearch = () => {
    updateCurrentFilter(currentFilter, dispatch);
    const usedInFilterConditions = searchCondition.map((item: SearchConditionItem) => ({ ...item, isUsedInFilter: true }));
    if (isCalledByCustomerList) {
      dispatch(actions.updateCustomerListSearchCondition.changeFilterState(usedInFilterConditions));
    } else {
      updateSearchCondition(usedInFilterConditions, dispatch);
    }

    setStorageValueByKey(SESSION_STORAGE_NEGOTATION_KEYS.PAGING_TABLE, {
      size: 200,
      from: 0,
    });
    setStorageValueByKey(SESSION_STORAGE_NEGOTATION_KEYS.CURRENT_PAGE, DEFAULT_PAGE_VIEW.CURRENT_PAGE);
    setStorageValueByKey(SESSION_STORAGE_NEGOTATION_KEYS.API_UPDATE_INDEX, DEFAULT_PAGE_VIEW.API_UPDATE_INDEX);
    // 絞り込みで 「検索」 ボタンを押下すると、商談一覧から1ページ目に戻ります。実行中のタスクのロジックに従って、1ページ目に設定されていない場合、前のページが保持される。
    setCurrentPage && setCurrentPage(DEFAULT_PAGE_VIEW.CURRENT_PAGE);
    setPaging &&
      setPaging({
        size: 200,
        from: 0,
      });
    setApiUpdateIndex && setApiUpdateIndex(DEFAULT_PAGE_VIEW.API_UPDATE_INDEX);
    // process data search condition before performing the search action
    const searchConditionRight = usedInFilterConditions.filter((item) => item?.specifiedCondition.length);
    search(loginUser, storeSelector, searchConditionRight, true, selectCodeInfo);
    const branchCount = searchCondition.filter(
      (key) => key.searchConditionName != freewordConditionName && !isDurationKey(key.searchConditionName),
    ).length;
    const branchCountWithCrew = searchCondition.filter(
      (key) =>
        (key.searchConditionName != freewordConditionName && key.specifiedCondition.length && !isDurationKey(key.searchConditionName)) ||
        key.checked,
    ).length;
    setSearchBranchCount && setSearchBranchCount(isSearchImprovement ? branchCountWithCrew : branchCount);
    onCloseDrawer();
  };

  const onClear = () => {
    setSearchCondition(initialSearchConditionState);
    setCurrentFilter(initialCurrentFilterState);
    setDuration(initialDurationState);
    setDurationValueFrom('');
    setDurationValueTo('');
    setFreewordConditionName(defaultFreewordConditionName);
  };

  const onAddFilter = (newSearchCondition: SearchConditionState) => {
    setCurrentFilter(initialCurrentFilterState);
    setSearchCondition(newSearchCondition);
  };

  const onCloseDrawer = () => {
    initializeFilterCondition();
    onClose();
  };

  /**
   * 店舗選択のフィルターを全てクリアする
   * @returns void
   */
  const onClickClearSelectedStores = () => {
    // 営業モジュールでない場合(agenciesがreduxStore上に存在しない場合)は何もしない
    if (!storeSelector.agencies) {
      return;
    }
    // すでに全てクリア済みである場合は、dispatchしない
    if (storeSelector.selectedStores.length === 0) {
      return;
    }
    dispatch(actions.storeSelector.clearSelectedStores());
  };

  /**
   * 店舗選択のフィルターを全て選択する
   * @returns void
   */
  const onClickSelectAllStores = () => {
    // 営業モジュールでない場合(agenciesがreduxStore上に存在しない場合)は何もしない
    if (!storeSelector.agencies) {
      return;
    }
    // すでに全て選択済みである場合は、dispatchしない
    if (storeSelector.selectedStores.length === storeSelector.modalSelectedStores.length) {
      return;
    }
    dispatch(actions.storeSelector.selectAllStores());
  };

  /**
   * 担当者である店舗のみを選択する
   * @returns void
   */
  const onClickSelectOnlyStoreInCharge = () => {
    // 営業モジュールでない場合(agenciesがreduxStore上に存在しない場合)は何もしない
    if (!storeSelector.agencies) {
      return;
    }
    // agenciesより、担当店舗を取得します
    const storesIsInCharge: string[] = [];
    for (const agencyCd of Object.keys(storeSelector.agencies)) {
      if (storeSelector.agencies[agencyCd].isStoreInCharge) {
        storesIsInCharge.push(agencyCd);
      }
    }
    // すでに担当店舗のみを選択済みである場合は、は何もしない
    // 非破壊でsortした結果を比較し一致を確認します
    if (storeSelector.selectedStores.slice().sort().toString() === storesIsInCharge.slice().sort().toString()) {
      return;
    }
    // reduxの状態を更新する()
    dispatch(actions.storeSelector.selectOnlyStoresInCharge());
  };

  const handleChangeCheckboxOnCustomerList = (key: string, value: string, checked: boolean) => {
    setIsCheckedMyCustomer(checked);
    let searchConditionTemp: SearchConditionState = [];
    searchConditionTemp = [...changeSeachCondition(key, value, checked)];
    setSearchCondition(searchConditionTemp);
  };

  const initializeFilterCondition = () => {
    setCurrentFilter(initialCurrentFilterState);
    setSearchCondition([]);
  };

  const getExistDurationInSearchConditionState = (searchConditions: SearchConditionState): Duration => {
    let durationCondition = '';

    for (const data of DURATION_DISPLAY_OPTIONS) {
      if (getFindIndex(searchConditions, data[0]) !== -1) {
        durationCondition = data[0];
        break;
      }
    }

    if (durationCondition) {
      return {
        category: durationCondition,
        value: getSpecifiedCondition(searchConditions, durationCondition),
      };
    } else {
      setDurationValueFrom('');
      setDurationValueTo('');
      return initialDurationState;
    }
  };

  const getFilterOption = (filterList: filterConditionState[], currentFilter: filterKeyState): FilterOption[] => {
    const options: FilterOption[] = [];
    const targetList = filterList.filter((filter) => filter.filterKey.trim() && filter.filterTitle.trim());
    if (targetList.length === 0) {
      options.push({ key: '', title: 'フィルターがありません', selected: true });
    } else {
      options.push({ key: '', title: 'フィルターを選択', selected: isExistCurrentFilter(currentFilter) });
      targetList.forEach((filter) => {
        options.push({ key: filter.filterKey, title: filter.filterTitle, selected: filter.filterKey === currentFilter.filterKey });
      });
    }
    return options;
  };

  const getConditionDisplayValue = (key: string): string => {
    const conditionTitle = getConditionTitle(searchCategory, key);
    const conditionsItems = searchCondition
      .filter((searchConditionItem) => searchConditionItem.searchConditionName === key)[0]
      .specifiedCondition.filter((value) => value == null || value.trim());

    if (conditionTitle && conditionsItems.length !== 0) {
      return `${'　'}${conditionTitle}: ${getItemNames(searchCategory, key, conditionsItems).join(',')}`;
    }
    return '';
  };

  const isExistCurrentFilter = (currentFilter: filterKeyState): boolean => {
    return !currentFilter.filterKey.trim();
  };

  const isExistKeyword = (): boolean => {
    const keywordValue = getSpecifiedCondition(searchCondition, freewordConditionName);
    return (
      getFindIndex(searchCondition, freewordConditionName) !== -1 &&
      keywordValue.filter((value) => value == null || value.trim()).length !== 0
    );
  };

  const isExistInDetailSearchConditions = (key: string, searchCondition: SearchConditionState): boolean => {
    const searchConditionValue = searchCondition.filter((searchConditionItem) => searchConditionItem.searchConditionName === key)[0]
      .specifiedCondition;
    return searchConditionValue.filter((value) => value == null || value.trim()).length > 0;
  };

  const isDurationKey = (key: string): boolean => {
    return DURATION_DISPLAY_OPTIONS.filter((val) => val[0] == key).length > 0;
  };

  const toggleStore = (store: StoreAndAgencyInfo) => () => {
    store && dispatch(actions.storeSelector.toggleStore(store));
  };

  const masterDetailinit = async () => {
    const { pcmCodeDivisionList } = await masterDetailApiGetAllPcmCode();
    const pcmCodeDivision = pcmCodeDivisionList.find((item) => {
      return item.pcmCdDivision === '0166';
    });
    if (pcmCodeDivision) {
      setSelectCodeInfo(pcmCodeDivision.pcmCodeList[0].pcmCd);
      setPcmCodeInfoList(pcmCodeDivision.pcmCodeList);
    }
  };
  useEffect(() => {
    if (isMailAddressSelect) {
      masterDetailinit();
    }
    fetchCustomFilter(filterList, loginUser.crewCd, dispatch);
    setIsDispStore(!isCrewModule);
  }, []);

  useEffect(() => {
    isOpen && onOpenDrawer();
  }, [isOpen]);

  useEffect(() => {
    if (gaSpotEvent) {
      Object.values(gaSpotEvent[FILTER_SECTIONS_KEY.DRAWER]).forEach(({ spotEvent, className }) => {
        document.querySelector(`.${className}`)?.setAttribute('onclick', spotEvent);
      });
    }
  }, []);
  useEffect(() => {
    if (disableAutoSearchByStoreSelector) {
      return;
    }
    // process data search condition before back to list screen from details screen...
    search(loginUser, storeSelector, getSearchConditionNoEmpty(globalSearchCondition), true, selectCodeInfo);
  }, [storeSelector, disableAutoSearchByStoreSelector]);

  useEffect(() => {
    // process data search condition when click button refresh
    updateRefresh(() => search(loginUser, storeSelector, getSearchConditionNoEmpty(globalSearchCondition), true, selectCodeInfo), dispatch);
  }, [loginUser, storeSelector, globalSearchCondition]);

  useEffect(() => {
    // on Change searchCondition
    if (isCalledByCustomerList) {
      if (searchCondition.length > 0) {
        setIsCheckedMyCustomer(searchCondition.find((item) => item.searchConditionName === 'customerCreateUser')?.checked || false);
        setIsCheckedMyNegotiation(searchCondition.find((item) => item.searchConditionName === 'mainClosingSalesmanName')?.checked || false);
      } else {
        setIsCheckedMyCustomer(false);
        setIsCheckedMyNegotiation(false);
      }
    }
  }, [searchCondition]);

  return (
    <>
      <Drawer className='filter-drawer' isOpen={isOpen} isOverayTransparent onClose={onCloseDrawer} position='right'>
        <div className='filter-drawer__inner'>
          <div className='filter-drawer__header'>
            <h3 className='headline-4 u-float-left'>絞り込み条件</h3>
            <IconButton
              className={classNames('u-float-right u-mn8', closeSpotEvent ? closeSpotEvent?.className : '')}
              data-testid-e2e='filterSettingDrawer-close'
              data-testid='filterSettingDrawer-close'
              icon='close'
              onClick={onCloseDrawer}
            />
          </div>
          <div className='filter-drawer__content'>
            <div className='uc-icon-textbox uc-icon-textbox--has-left-right-icon u-max-w-full u-mb24' style={{ width: '560px' }}>
              <Icon className='uc-icon-textbox__icon uc-icon-textbox__icon--left'>tune</Icon>
              <select
                className='uc-textbox'
                onChange={(e) => onChangeFilter(e.target.value)}
                disabled={filterList.length === 0}
                data-testid='filterSettingDrawer-filter-select'
                data-testid-e2e='filterSettingDrawer-filter-select'>
                {getFilterOption(filterList, currentFilter).map((option) => (
                  <option key={option.key} value={option.key} selected={option.selected}>
                    {option.title}
                  </option>
                ))}
              </select>
              <Icon className='uc-icon-textbox__icon uc-icon-textbox__icon--right'>arrow_drop_down</Icon>
            </div>
            <hr className='uc-divider u-mb8 u-mhn16' />
            <div className='uc-form-field u-mt24'>
              <div className='uc-form-field__label'>フリーワード</div>
              <ButtonGroup className='u-mv8 btn-group__freeword-search-container'>
                {currentFreewordMapping.map(({ label, conditionName, dataTestId }: FreewordConditionNameType) => (
                  <ButtonGroup.Button
                    isActive={freewordConditionName === conditionName}
                    label={label}
                    onClick={() => onChangeFreewordConditionName(conditionName)}
                    data-testid={dataTestId}
                    data-testid-e2e={dataTestId}
                  />
                ))}
              </ButtonGroup>
              {freewordConditionName === defaultFreewordConditionName && (
                <div
                  className='u-text-s u-mb8 freeword-description'
                  data-testid='freeword-description'
                  data-testid-e2e='freeword-description'>
                  {DESCRIPTION_FREEWORD_FIELD[isSearchImprovement ? 'CREW' : 'OTHER']}
                </div>
              )}
              <div className='uc-form-field__control'>
                <div className='uc-icon-textbox uc-icon-textbox--has-right-icon u-w-full' data-testid='freeword'>
                  <input
                    ref={freewordRef}
                    type='text'
                    className='uc-textbox'
                    placeholder=''
                    value={
                      searchCondition.filter((key) => key.searchConditionName === freewordConditionName).length > 0
                        ? getSpecifiedCondition(searchCondition, freewordConditionName).join(' ')
                        : ''
                    }
                    onChange={(e) => onChangeFreeword(e.target.value)}
                    data-testid='filterSettingDrawer-input-keyword'
                  />
                  {isExistKeyword() && (
                    <Button
                      onClick={() => onChangeFreeword('')}
                      className='uc-icon-textbox__icon-button uc-icon-textbox__icon--right'
                      leftIcon='close'
                      data-testid='filterSettingDrawer-clear-keyword'
                    />
                  )}
                </div>
              </div>
            </div>
            <div className='uc-form-field u-mt24'>
              <div className='uc-form-field__label'>期間</div>
              <div className='uc-form-field__control'>
                <div className='uc-icon-textbox u-w-full u-mb8'>
                  <select
                    className='uc-textbox'
                    data-testid='filterSettingDrawer-duration-select'
                    onChange={(e) => onChangeDuration(e.target.value)}
                    value={duration.category}>
                    {DURATION_DISPLAY_OPTIONS.map((options) => {
                      return (
                        <option key={options[0]} value={options[0]}>
                          {options[1]}
                        </option>
                      );
                    })}
                  </select>
                  <Icon className='uc-icon-textbox__icon uc-icon-textbox__icon--right'>arrow_drop_down</Icon>
                </div>
                {duration.category && (
                  <Form>
                    <Form.Fileld labelFor='templateSelect'>
                      <div className='u-flex u-align-center uc-textbox--wml'>
                        <div
                          data-testid-e2e='filterSettingDrawer-duration-from-input'
                          data-testid='filterSettingDrawer-duration-from-input'>
                          <ActDatepicker
                            isClearable={true}
                            popperPlacement='bottom-start'
                            value={
                              durationValueFrom
                                ? durationValueFrom <= DATE_YYYYMMDD.MIN
                                  ? ''
                                  : formatDate(durationValueFrom, 'YYYYMMDD', 'YYYY/MM/DD')
                                : ''
                            }
                            defaultSelected={inquiryToday}
                            onChange={(dt) => {
                              if (dt) {
                                onChangeDurationValue(DURATION.FROM, dt?.toLocaleString());
                              } else {
                                onChangeDurationValue(DURATION.FROM, '');
                              }
                            }}
                            onTodayButtonClick={() => {
                              if (inquiryToday) {
                                onChangeDurationValue(
                                  DURATION.FROM,
                                  formatDateNull(inquiryToday.toLocaleString(), 'YYYY/MM/DD HH:mm:ss', 'YYYY-MM-DD'),
                                );
                              } else {
                                onChangeDurationValue(DURATION.FROM, '');
                              }
                            }}
                          />
                        </div>

                        <span className='uc-form-field__inner-text u-text-center' style={{ flex: 1 }}>
                          〜
                        </span>

                        <div data-testid-e2e='filterSettingDrawer-duration-to-input' data-testid='filterSettingDrawer-duration-to-input'>
                          <ActDatepicker
                            isClearable={true}
                            popperPlacement='bottom-start'
                            value={
                              durationValueTo
                                ? durationValueTo >= DATE_YYYYMMDD.MAX
                                  ? ''
                                  : formatDate(durationValueTo, 'YYYYMMDD', 'YYYY/MM/DD')
                                : ''
                            }
                            defaultSelected={inquiryToday}
                            onChange={(dt) => {
                              if (dt) {
                                onChangeDurationValue(DURATION.TO, dt?.toLocaleString());
                              } else {
                                onChangeDurationValue(DURATION.TO, '');
                              }
                            }}
                            onTodayButtonClick={() => {
                              if (inquiryToday) {
                                onChangeDurationValue(
                                  DURATION.TO,
                                  formatDateNull(inquiryToday.toLocaleString(), 'YYYY/MM/DD HH:mm:ss', 'YYYY-MM-DD'),
                                );
                              } else {
                                onChangeDurationValue(DURATION.TO, '');
                              }
                            }}
                          />
                        </div>
                      </div>
                    </Form.Fileld>
                  </Form>
                )}
              </div>
            </div>
            <div className='uc-form-field u-mt24'>
              <div className='uc-form-field__label'>追加条件</div>
              {isSearchImprovement &&
                (!isCalledByCustomerList ? (
                  <>
                    {listCheckboxSalesManCdName.map((salesManCd) => (
                      <div key={salesManCd.key}>
                        <Checkbox
                          data-testid={salesManCd.dataTestId}
                          data-testid-e2e={salesManCd.dataTestId}
                          className='u-ml'
                          labelClassName='u-mv8 u-h-auto'
                          label={salesManCd.label}
                          name='example-checkbox'
                          onChange={(e) => {
                            let searchConditionTemp: SearchConditionState = [];
                            searchConditionTemp = [...changeSeachCondition(salesManCd.key, salesManCd.value, e.target.checked)];
                            setSearchCondition(searchConditionTemp);
                          }}
                          checked={isChecked(salesManCd.key)}
                        />
                      </div>
                    ))}
                  </>
                ) : (
                  <>
                    <div key={'myCustomer'}>
                      <Checkbox
                        data-testid={'filterSettingDrawer-checkbox-myCustomer'}
                        data-testid-e2e={'filterSettingDrawer-checkbox-myCustomer'}
                        className='u-ml'
                        labelClassName='u-mv8 u-h-auto'
                        label={'自分が登録したお客さま'}
                        name='myCustomer-checkbox'
                        onChange={(e) => {
                          handleChangeCheckboxOnCustomerList('customerCreateUser', loginUser.crewCd, e.target.checked);
                        }}
                        checked={isCheckedMyCustomer}
                      />
                    </div>
                    <div key={'myNegotiation'}>
                      <Checkbox
                        disabled={!hasCrewNameOnSearchCategories}
                        data-testid={'filterSettingDrawer-checkbox-myNegotiation'}
                        data-testid-e2e={'filterSettingDrawer-checkbox-mainClosingSaleManName'}
                        className='u-ml'
                        labelClassName='u-mv8 u-h-auto'
                        label={'自分が担当している商談を含むお客さま'}
                        name='myNegotiation-checkbox'
                        onChange={(e) => {
                          handleChangeCheckboxOnCustomerList('mainClosingSalesmanName', loginUser.crewName, e.target.checked);
                        }}
                        checked={isCheckedMyNegotiation}
                      />
                    </div>
                  </>
                ))}
              <Button
                className={classNames(
                  'uc-button u-mb16 u-mt8 uc-button--outlined uc-button--w-full',
                  addConditionSpotEvent ? addConditionSpotEvent?.className : '',
                )}
                height='s'
                leftIcon='add'
                onClick={() => setIsOpenFilterSettingModal(true)}
                label='さらに条件を追加'
                data-testid='filterSettingDrawer-open-modal'
              />
              <div className='uc-form-field__label　u-float-left u-mb16'>
                <span className='filter-drawer__collapse' onClick={() => setIsCollapsedOther(!isCollapsedOther)}>
                  <Icon className={classNames('filter-drawer__arrow-icon', isCollapsedOther && 'is-rotate')}>keyboard_arrow_up</Icon>
                  <span className='u-text-middle u-text-bold'>適用されている条件</span>
                </span>
              </div>
              <Collapse in={!isCollapsedOther}>
                <div className='uc-form-field__control' data-testid-e2e='detail_condition_area'>
                  {searchCondition.filter(
                    (key) =>
                      key.searchConditionName != freewordConditionName &&
                      key.searchConditionName != 'dummyFlg' &&
                      key.searchConditionName != 'productInfo' &&
                      key.searchConditionName != 'actionInfo' &&
                      key.searchConditionName != 'undispFlg' &&
                      key.searchConditionName != 'resurrectionFlg' &&
                      !(key.searchConditionGroupId !== 0 && key.searchConditionName === 'commodityCategoryType') &&
                      !(key.searchConditionGroupId !== 0 && key.searchConditionName === 'mobileContractType') &&
                      !(key.searchConditionGroupId !== 0 && key.searchConditionName === 'actionType') &&
                      key.searchConditionName !== 'negotiationResultType' &&
                      !isDurationKey(key.searchConditionName) &&
                      isExistInDetailSearchConditions(key.searchConditionName, searchCondition),
                  ).length === 0 ? (
                    <>
                      <p className='u-text-m u-text-disabled'>設定されていません</p>
                    </>
                  ) : (
                    <>
                      {searchCondition
                        .filter(
                          (key) =>
                            key.searchConditionName != freewordConditionName &&
                            key.searchConditionName != 'dummyFlg' &&
                            key.searchConditionName != 'productInfo' &&
                            key.searchConditionName != 'actionInfo' &&
                            key.searchConditionName != 'undispFlg' &&
                            key.searchConditionName != 'resurrectionFlg' &&
                            !(key.searchConditionGroupId !== 0 && key.searchConditionName === 'commodityCategoryType') &&
                            !(key.searchConditionGroupId !== 0 && key.searchConditionName === 'mobileContractType') &&
                            !(key.searchConditionGroupId !== 0 && key.searchConditionName === 'actionType') &&
                            key.searchConditionName !== 'negotiationResultType' &&
                            !isDurationKey(key.searchConditionName),
                        )
                        .filter((key) => isExistInDetailSearchConditions(key.searchConditionName, searchCondition))
                        .map((key) => {
                          const showCustomerCreateUser = isCalledByCustomerList && key.searchConditionName === 'customerCreateUser';
                          return (
                            <div
                              key={key.searchConditionName}
                              className={`uc-tag uc-tag--clickable uc-tag--large u-mr8 u-mb8 u-max-w-full ${
                                showAllConditionDisplayValue === key.searchConditionName && 'u-h-auto u-min-hs'
                              }`}
                              data-testid='detail_condition'>
                              <p
                                style={
                                  showAllConditionDisplayValue === key.searchConditionName
                                    ? { maxWidth: '95%' }
                                    : { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '95%' }
                                }
                                data-testid='search-condition-single-value'
                                onClick={() => !showCustomerCreateUser && setShowAllConditionDisplayValue(key.searchConditionName)}>
                                {showCustomerCreateUser
                                  ? `${'　'}お客さま登録者: ${loginUser.crewName}`
                                  : getConditionDisplayValue(key.searchConditionName)}
                              </p>
                              <Button
                                data-testid='clear-search-condition-single-value'
                                className='uc-tag__close-button'
                                style={{ width: 'auto', height: 'auto' }}
                                iconClassName='u-text-l'
                                onClick={() => onRemoveSearchConditionSingleValue(key.searchConditionName)}
                                leftIcon='close'
                              />
                            </div>
                          );
                        })}
                    </>
                  )}
                </div>
              </Collapse>
            </div>
            {storeFilterNode}
            {isDispStore ? (
              <>
                <hr className='uc-divider u-mb8 u-mhn16' />
                <div className='uc-form-field u-mt24'>
                  <div className='uc-form-field__label　u-float-left u-mb16'>
                    <span className='filter-drawer__collapse' onClick={() => setIsCollapsedStore(!isCollapsedStore)}>
                      <Icon className={classNames('filter-drawer__arrow-icon', isCollapsedStore && 'is-rotate')}>keyboard_arrow_up</Icon>
                      <span className='u-text-middle u-text-bold'>表示する店舗</span>
                    </span>
                    {/* クリックして店舗選択モーダルを表示する */}
                    <Button
                      className='u-w5s u-float-right'
                      type='transparent'
                      height='s'
                      leftIcon='store'
                      label='店舗/店舗フィルタを選択'
                      onClick={() => dispatch(actions.storeSelector.toggleModal())}
                    />
                  </div>

                  <Collapse in={!isCollapsedStore}>
                    {isEmployeeModule && (
                      <>
                        <div className='clearfix u-mb8 u-mx8'>
                          <div className='u-float-left'>
                            <Button
                              className='u-mx8'
                              type='transparent'
                              onClick={onClickSelectOnlyStoreInCharge}
                              height='s'
                              width='s'
                              label='担当店舗のみ選択'
                              data-testid='select-only-store-in-charge'
                            />
                            <Button
                              className='u-mx8'
                              type='transparent'
                              onClick={onClickClearSelectedStores}
                              height='s'
                              width='2s'
                              label='全てクリア'
                              data-testid='clear-selected-stores'
                            />
                            <Button
                              className='u-mx8'
                              type='transparent'
                              onClick={onClickSelectAllStores}
                              height='s'
                              width='2s'
                              label='全て選択'
                              data-testid='select-all-stores'
                            />
                          </div>
                        </div>
                        <hr className='uc-divider u-mb8 u-mhn16' />
                      </>
                    )}
                    <div className='uc-form-field__control'>
                      {
                        // 営業モジュールの場合
                        storeSelector.agencies
                          ? [...Object.values(storeSelector.agencies)]
                              // 店舗選択モーダルにて、選択済みの店舗のみを表示します
                              .filter((item) => storeSelector.modalSelectedStores.includes(item.agencyCd))
                              // 第一ソートキー:企業正式名称、第二ソートキー:取次店略称
                              // にて並び替えて表示します
                              .sort((a, b) => {
                                for (const sortField of SORT_FIELDS) {
                                  const compare = String(a[sortField]).localeCompare(String(b[sortField]), 'ja');
                                  if (compare !== 0) return compare;
                                }
                                return a.agencyCd.localeCompare(b.agencyCd, 'ja');
                              })
                              .map((store) => (
                                <Badge
                                  className='agency-store-tag u-mr8 u-mb8'
                                  activeClassName='agency-store-tag--active'
                                  isActive={store.selectedForFilter ?? false}
                                  onClick={toggleStore(store)}>
                                  {/* (企業名正式名称)取次店略称 の形式にて、値を表示します */}
                                  {getCompanyCfcDisplayName(String(store.companyCfc), store.shortName)}
                                </Badge>
                              ))
                          : // 代理店モジュールの場合
                            storeSelector.sortedModalSelectedStores
                              .map((agencyCd) => storeSelector.stores?.[agencyCd])
                              .map(
                                (store: StoreInfo | undefined) =>
                                  store && (
                                    <Badge
                                      className='agency-store-tag u-mr8 u-mb8'
                                      activeClassName='agency-store-tag--active'
                                      isActive={store?.selectedForFilter ?? false}
                                      onClick={toggleStore(store)}>
                                      {getAgencyStoreShortName(store.shortName, store.agencyCd, String(store.companyCfc))}
                                    </Badge>
                                  ),
                              )
                      }

                      {['dev'].includes(process.env.REACT_APP_ENV ?? '') && (
                        <>
                          {/* スタイリング見せるため */}
                          {['ソフトバンク舞浜', 'ソフトバンク桜木町', 'ソフトバンク赤坂'].map((item, index) => (
                            <Badge className='agency-store-tag u-mr8 u-mb8' activeClassName='agency-store-tag--active' isActive={index > 3}>
                              {item}
                            </Badge>
                          ))}
                          <p className='u-text-m u-text-disabled'>設定されていません</p>;
                        </>
                      )}
                    </div>
                  </Collapse>
                </div>
              </>
            ) : (
              <>{children}</>
            )}
            {isMailAddressSelect && (
              <>
                <div className='uc-form-field__label'>除外条件</div>
                <Select
                  disabled={false}
                  width='full'
                  value={selectCodeInfo}
                  onChange={(e) => {
                    setSelectCodeInfo(e.target.value);
                  }}>
                  {pcmCodeInfoList.map((item, index) => (
                    <Select.Option data-testid='scheduleTimeStartHourOpt' value={item.pcmCd} key={index}>
                      {item.pcmCdNm}
                    </Select.Option>
                  ))}
                </Select>
                <div className='uc-file-uploader__explain uc-button--min-w100p u-text-bold u-pt4'>
                  以下の条件に当てはまる宛先は条件に合致しても結果一覧には表示されません。
                </div>
                <div className='uc-step__help uc-button--min-w100p u-ml4'>・直近30日以内に同一のテンプレートの内容を送信した宛先</div>
                <div className='uc-step__help  uc-button--min-w100p u-ml4'>・個別送信・一斉送信を合わせて、当月中に3回送信した宛先</div>
                <div className='uc-step__help  uc-button--min-w100p u-ml4'>
                  ・個別に除外設定で「一斉メールの送信を許可しない」を選択している宛先
                </div>
              </>
            )}
          </div>
          <div className='filter-drawer__footer'>
            <Button
              onClick={onClear}
              className={classNames('u-float-left', clearSpotEvent ? clearSpotEvent?.className : '')}
              type='transparent'
              label='クリア'
            />
            <Button
              className={classNames('u-mbn8', executeSpotEvent ? executeSpotEvent?.className : '')}
              width='s'
              label='絞り込み'
              onClick={onSearch}
              data-testid-e2e='filterSettingDrawer-execute'
              data-testid='filterSettingDrawer-execute'
            />
          </div>
        </div>
      </Drawer>
      <FilterSettingModal
        isOpen={isOpenFilterSettingModal}
        gaSpotEvent={gaSpotEvent && gaSpotEvent[FILTER_SECTIONS_KEY.MODAL]}
        isSearchImprovement={isSearchImprovement}
        onClose={() => setIsOpenFilterSettingModal(false)}
        searchCondition={searchCondition}
        searchCategoryFetch={searchCategory}
        onAddFilter={(newSearchCondition: SearchConditionState) => onAddFilter(newSearchCondition)}
      />
      {isOpenStoreSelectModal && (
        <StoreSelectModal
          isOpen
          onClose={() => setIsOpenStoreSelectModal(false)}
          postCd={postCd ?? ''}
          filterStores={filterStore}
          stores={loginUser.stores || []}
          targetStores={storeSelector.modalSelectedStores ?? []}
          updateTargetStore={(targetStores: string[]) => {
            dispatch(actions.storeSelector.updateSelectedStores(targetStores));
          }}
          updateLocalTargetStore={(targetStores: string[]) => {
            dispatch(actions.storeSelector.updateLocalStores(targetStores));
          }}
        />
      )}
    </>
  );
};

export default FilterSettingDrawer;
